import React from "react";

export const Checkbox = ({
                           checked,
                           onChange,
                           label,
                           disabled = false,
                           children,
                         }) => {
  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  return (
      <label className={`checkbox-container ${disabled ? "disabled" : ""}`}>
        <input
            type="checkbox"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
        />
        <span className="checkmark"/>

        {children && <span className="checkbox-label">{children}</span>}
      </label>
  );
};